import styled from 'styled-components';

export const LocationInputWrapper = styled.div`
  height: 48px;
`;
